import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import closeIcon from "../../../../../../../public/images/close-icon.svg";
import styles from "./styles.module.scss";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (_name: string) => void;
  pending?: boolean;
}

const CreateWorkflowModal = ({ isOpen, onClose, onCreate, pending }: IProps) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError(t("Workflow name is required"));
      return;
    }
    onCreate(trimmed);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && name.trim() && !pending) {
      handleSubmit();
    }
  };

  const handleClose = () => {
    setName("");
    setError("");
    onClose();
  };

  return (
    <ModalLayout isOpen={isOpen} onClose={handleClose} classNames={styles.modal_popup}>
      <div className={styles.modal}>
        <div className={styles.modal_header}>
          <h2 className={styles.modal_title}>{t("New Workflow")}</h2>
          <img
            src={closeIcon}
            alt="close"
            className={styles.close_icon}
            onClick={handleClose}
          />
        </div>

        <label className={styles.label}>{t("Workflow Name")}</label>
        <input
          type="text"
          className={styles.input}
          placeholder={t("Enter workflow name...")}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (error) {
              setError("");
            }
          }}
          onKeyDown={handleKeyDown}
          autoFocus
        />
        {error && <span className={styles.error}>{error}</span>}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancel_btn}
            onClick={handleClose}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className={styles.create_btn}
            onClick={handleSubmit}
            disabled={pending || !name.trim()}
          >
            {pending ? t("Creating...") : t("Create")}
          </button>
        </div>
      </div>
    </ModalLayout>
  );
};

export default CreateWorkflowModal;
